import baustein from "baustein";
import globalEvents from "web/script/utils/global-events";
import analytics from "web/script/analytics/analytics";
import userProfiler from "web/script/modules/userprofiler";

export default baustein.register("crm-survey", {
    setupEvents(add) {
        add("change", "input[name='crm-survey']", this.onAnswerClick);
        add("click", ".crm-survey__submit", this.onSubmit);
    },

    onInsert() {
        userProfiler.setCrmSurveyShown();
    },

    onAnswerClick() {
        const submitBtn = this.el.querySelector(".crm-survey__submit");
        submitBtn.disabled = false;
    },

    onSubmit() {
        const selectedAnswer = this.el.querySelector("input[name='crm-survey']:checked");
        const answer = selectedAnswer.value;
        const payload = {
            _type: "survey_responses",
            _version: "0.0.1",
            survey_id: "crm-survey",
            response_json: JSON.stringify({
                question: this.el.querySelector(".crm-survey__question").textContent,
                answer,
            }),
        };

        analytics.trackWithMetaData("survey_response", payload);
        analytics.event("crm-survey", "submit", answer);

        this.close();
    },

    close() {
        globalEvents.trigger("crm-survey-closed");
        return this.destroy();
    },
});
